import { Dispatch, SetStateAction } from 'react'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { NextRouter } from 'next/router'

type ActionsForNextRouterPush = Parameters<NextRouter['push']>;

type ActionsForAppRouterPush = Parameters<AppRouterInstance['push']>;

type HandleActionLink = {
  action: string;
  target?: string;
  router?: never;
}

type HandleActionFunction = {
  action: Function;
  router?: never;
  target?: never;
}

type HandleActionWithAppRouter = {
  action: ActionsForAppRouterPush[0] | ActionsForAppRouterPush;
  router: AppRouterInstance;
  target?: never;
};

type HandleActionWithNextRouter = {
  action: ActionsForNextRouterPush[0] | ActionsForNextRouterPush;
  router: NextRouter;
  target?: never;
};


export type HandleActionParams = {
  setIsLoading?: Dispatch<SetStateAction<boolean>>
} & (HandleActionLink | HandleActionFunction | HandleActionWithAppRouter | HandleActionWithNextRouter);

/**
 * Handle router action
 *
 * @param props HandleActionParams
 * @returns
 */
export async function handleAction(props: HandleActionParams): Promise<any> {
  const {
    action,
    router,
    setIsLoading: customSetIsLoading,
    target,
  } = props;

  const setIsLoading = typeof customSetIsLoading === 'function' ? customSetIsLoading : (() => null);

  // HandleActionFunction
  if (typeof action === 'function') {
    setIsLoading(true);
    const result = await action.call(null);
    setIsLoading(false);

    return result;
  }

  setIsLoading(true);

  // HandleActionWithAppRouter | HandleActionWithNextRouter
  if (router) {
    if (target) {
      throw new Error('Router do not supports "target" in "handleAction".');
    }

    const args: (ActionsForNextRouterPush | ActionsForAppRouterPush) = Array.isArray(action) ? action : [ action ];
    return router.push.apply(null, args);
  }

  // HandleActionLink
  if (target !== '_self') {
    setIsLoading(false);
  }

  return window.open(action, (target || '_self'));
}
